import { render, staticRenderFns } from "./user-list.vue?vue&type=template&id=78d4cab6&scoped=true"
import script from "./user-list.vue?vue&type=script&lang=js"
export * from "./user-list.vue?vue&type=script&lang=js"
import style0 from "./user-list.vue?vue&type=style&index=0&id=78d4cab6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d4cab6",
  null
  
)

export default component.exports